/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import * as R from 'ramda'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import './styles/treeviewSelect.scss'
import isEqual from 'lodash/isEqual'

class TreeviewSelect extends Component {
    values = []

    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate)
        }

        this.state = {
            isInvalid: false,
            numSelected: props.numSelected || 0,
            hasChanged: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name } = this.props

        if (typeof unregister === 'function') {
            unregister(name)
        }
    }

    validate = ({ value, name }, setState = false) => {
        const { isMandatory, validate } = this.props

        const hasValue = R.and(!R.isNil(value), !R.isEmpty(value))
        let isValid = !isMandatory || hasValue
        if (typeof validate === 'function') {
            isValid = isValid && validate({ value, name })
        }

        if (setState) {
            this.setState({
                isInvalid: !isValid,
            })
        }

        return isValid
    }

    onBlur = () => {
        const { name, onBlur } = this.props
        const { hasChanged } = this.state
        const { values } = this

        this.setState({
            isInvalid: !this.validate({ value: values, name }),
        })

        if (!hasChanged) return

        if (typeof onBlur === 'function') {
            onBlur({ value: values, name })
        }
    }

    getDeepestNestedItems = (path, values) => {
        const { options, returnAllSelectedNodes } = this.props
        const items = options ? R.path(path, options) : R.path(path, this.data)
        if (!items.children || !items.children.length) {
            values.push(items)
            return
        }
        if (returnAllSelectedNodes) {
            values.push(items)
        }
        items.children.forEach((item, i) => {
            this.getDeepestNestedItems([...path, 'children', i], values)
        })
    }

    addPartialParents = (path, parentPaths) => {
        const { options } = this.props
        const newPath = [...path]
        newPath.pop()
        if (!newPath.length) return
        const currentPath = []
        newPath.forEach((p, i) => {
            if (i === 0) {
                currentPath.push(p)
            } else {
                currentPath.push(...['children', p])
            }
            if (parentPaths.includes(currentPath.join())) return
            parentPaths.push(currentPath.join())
            const items = options ? R.path(currentPath, options) : R.path(currentPath, this.data)
            this.values.push(items)
        })
    }

    onChange = (currentNode, selectedNodes) => {
        const {
            returnDeepNested, onChange, name, returnAllSelectedNodes, returnPartiallySelected,
        } = this.props
        this.values = []
        const parentPaths = []
        if (returnDeepNested || returnAllSelectedNodes) {
            selectedNodes.forEach((v) => {
                const selectionId = v._id
                const selectionPosition = selectionId.split('-')
                selectionPosition.shift()
                if (returnPartiallySelected) this.addPartialParents(selectionPosition, parentPaths)
                const selectionPath = selectionPosition.map((e, i) => (i === 0 ? e : ['children', e])).flat(2)
                this.getDeepestNestedItems(selectionPath, this.values)
            })
        } else {
            this.values = selectedNodes
        }

        this.setState({ numSelected: this.values.length, hasChanged: true })
        if (typeof onChange === 'function') {
            onChange({ value: this.values, name })
        }
    }

    renderInput = () => {
        const {
            name, placeholder, emptyError,
            cssClass, label, style,
            searchPlaceholder, options, showPartiallySelected,
        } = this.props
        const {
            isInvalid, numSelected,
        } = this.state

        const validClass = isInvalid
            ? 'empty-error'
            : ''

        let elem = ''
        elem = (
            <div className={`treeviewSelect ${cssClass} ${validClass}`} style={style}>
                {label && (
                    <label className="treeviewLabel" htmlFor={`treeview ${name}`} style={{ display: 'flex' }}>
                        {label}
                        <span style={{ marginLeft: '8px' }}>
                            {` - ${numSelected} Selected`}
                        </span>
                    </label>
                )}
                <TreeviewSelectWrapper
                    data={options}
                    onChange={this.onChange}
                    texts={{ placeholder: placeholder || 'Select...', inlineSearchPlaceholder: searchPlaceholder || 'Search...' }}
                    onBlur={this.onBlur}
                    inlineSearchInput
                    keepTreeOnSearch
                    showPartiallySelected={showPartiallySelected}
                />
                {(emptyError && isInvalid) && (
                    <p className="error-msgs">{emptyError}</p>
                )}
            </div>
        )

        return elem
    }

    render() {
        return this.renderInput()
    }
}
// this is to prevent the component resetting itself on each Render.
class TreeviewSelectWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = { data: props.data }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        const { data } = this.state
        if (!isEqual(nextProps.data, data)) {
            this.setState({ data: nextProps.data })
        }
    }

    shouldComponentUpdate = (nextProps) => !isEqual(nextProps.data, this.state.data)

    render() {
        const { data } = this.state
        const { ...rest } = this.props
        return (
            <DropdownTreeSelect data={data} {...rest} />
        )
    }
}

export default TreeviewSelect
